import { View } from "react-native";
import { colors } from "../../theme";
import { CheckboxItem as StyledCheckboxItem } from "./styled";
import { ErrorHelperText } from "./TextInput";

export interface Props extends Omit<React.ComponentProps<typeof StyledCheckboxItem>, "status" | "theme" | "onPress" | "mode"> {
  value: boolean;
  onChange: (value: boolean) => void;
  error?: { message?: string };
}

const CheckboxItem = ({ value, onChange, error, ...props }: Props) => (
  <View>
    {!!error?.message && <ErrorHelperText error={error}>{error?.message}</ErrorHelperText>}

    <StyledCheckboxItem
      theme={{ colors: { onSurfaceVariant: colors.sky.dark } }}
      position="leading"
      status={value ? "checked" : "unchecked"}
      mode="android"
      onPress={() => {
        onChange(!value);
      }}
      {...(!!error?.message && { uncheckedColor: colors.red.dark })}
      {...props}
    />
  </View>
);

export default CheckboxItem;
